export default "__VITE_ASSET__CEB1MNPO__"